@let batteryLevel = batteryLevel$ | async;

<div class="battery-level">
    <span class="percentage" data-testid="label">
        {{ value$ | async }}
    </span>
    <mat-icon
            data-testid="battery-icon"
            [matTooltip]="tooltip$ | async"
            (click)="clicked.emit()"
            class="icon"
            [ngClass]="{
      'low': batteryLevel === 'LOW',
      'medium': batteryLevel === 'MEDIUM',
      'normal': batteryLevel === 'NORMAL',
    }">
        {{ this.icons[batteryLevel] }}
    </mat-icon>
</div>